module.exports = __webpack_public_path__ + "public/images/coding.514cdc4e9def6d30f2c102d136673083.png";